import IssueTemplateList from "./IssueTemplateList";
import IssueTemplateEdit from "./IssueTemplateEdit";
import IssueTemplateCreate from "./IssueTemplateCreate";

export default {
    list: IssueTemplateList,
    edit: IssueTemplateEdit,
    create: IssueTemplateCreate,
};
